import actionCreatorFactory from 'typescript-fsa';
import { ApiFieldError } from 'src/types';

export const actionCreator = actionCreatorFactory(
  `@manager/features/properties`
);
export type APIError = ApiFieldError;

export const describepropertiesRequest = actionCreator('request');

export const describepropertiesSuccess = actionCreator<any>('request-success');
export const describepropertiesFail = actionCreator<any>('request-fail');

export const updatepropertiesActions = actionCreator.async<
  any,
  any,
  APIError[]
>(`update`);
